var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg031Safety = function Svg031Safety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M436 286h41.483C463.9 219.102 419.599 163.067 361 132.072V211c0 41.353 33.647 75 75 75M151 211v-78.928C92.401 163.067 49.1 219.102 35.517 286H76c41.353 0 75-33.647 75-75M0 376h512v60H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 331v15h451v-15c0-5.065-.427-10.02-.756-15H436c-57.891 0-105-47.109-105-105V106h-30v150h-30V76h-30v180h-30V106h-30v105c0 57.891-47.109 105-105 105H31.756c-.329 4.98-.756 9.935-.756 15"
  })));
};
export default Svg031Safety;